<template>
  <div class="masonry">
    <div class="masonry-grid">
      <div
        v-for="(image, index) in searchResults"
        :key="image.id"
        class="masonry-item"
        data-micromodal-trigger="modal-libris-image"
      >
        <img
          :src="imageLink(image)"
          class="masonry-content"
          @click="handleImageClick(index)"
        />
        <div
          v-if="
            image.includes[
              'custom-metadata'
            ].data.attributes.custom_metadata.find(
              metafield => metafield.value == 'mural'
            )
          "
          class="scale-icons"
        >
          <span class="icon-single-panel">
            <img
              src="/static/icons/SVG/icon-single-panel.svg"
              alt="Single Panel Image"
            />
          </span>
          <span class="icon-single-panel">
            <img
              src="/static/icons/SVG/icon-mural-panel.svg"
              alt="Mural Panel Image"
            />
          </span>
        </div>

        <div v-else class="scale-icons">
          <span class="icon-single-panel">
            <img
              src="/static/icons/SVG/icon-single-panel.svg"
              alt="Single Panel Image"
            />
          </span>
        </div>
      </div>
    </div>
    <NoResultsOrError
      v-if="searchResults.length === 0"
      :results="searchResults"
      :apiCallMade="apiCallMade"
      :error="error"
      :no-results-message="noResultsMessage"
      :no-results-redirect="noResultsRedirect"
      :no-results-redirect-text="noResultsRedirectText"
    />
    <Pagination
      :current-page="currentPage"
      :total-results="totalResults"
      :per-page="perPage"
      :total-pages="totalPages"
    />
  </div>
</template>

<script>
import { eventBus } from '../shared/event-bus';
import Pagination from './Pagination';
import NoResultsOrError from '../shared/NoResultsOrError';

export default {
  name: 'MasonryGrid',
  components: {
    NoResultsOrError,
    Pagination,
  },
  props: [
    'searchResults',
    'error',
    'apiCallMade',
    'currentPage',
    'totalResults',
    'perPage',
    'totalPages',
    'noResultsMessage',
    'noResultsRedirect',
    'noResultsRedirectText',
  ],
  methods: {
    handleImageClick(index) {
      eventBus.updateActiveImageIndex(index);
    },
    imageLink(image) {
      return image.includes.link.data.attributes.link.replace(
        /m\.psecn\.photoshelter\.com/,
        'psecn.photoshelter.com'
      );
    },
  },
};
</script>
